import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { useState, useEffect, useRef } from 'react';
import { observeElementIntersect } from "../../shared/utils/lazyloading/lazyloading";
import clsx from 'clsx';
import { useMergeRefs } from "../../hooks/useMergeRefs/useMergeRefs";
function setSrc(target) {
    if (target && target.dataset) {
        if (target.dataset.src) {
            target.setAttribute('src', target.dataset.src);
            target.removeAttribute('data-src');
        }
        else if (target.dataset.srcset) {
            target.setAttribute('srcset', target.dataset.srcset);
            target.removeAttribute('data-srcset');
        }
    }
}
function LazyLoadContainer({ lazyload = true, lazyClass = '', children, className, component, ref, ...other }) {
    const lazyLoadContainer = useRef(null);
    const [isIntersecting, setIntersecting] = useState(false);
    const mergedRefs = useMergeRefs([ref, lazyLoadContainer]);
    useEffect(() => {
        function setLazyClass() {
            setIntersecting(true);
        }
        if (lazyload && lazyLoadContainer.current) {
            const lazyImages = [
                ...lazyLoadContainer.current.querySelectorAll('img[data-src], img[data-srcset], source[data-srcset], video[data-src], video[data-srcset], iframe[data-src], iframe[data-srcset]'),
            ];
            if (lazyImages.length) {
                observeElementIntersect(lazyImages, setSrc, { rootMargin: '150px' });
            }
            if (lazyClass) {
                const lazyImage = [lazyLoadContainer.current];
                observeElementIntersect(lazyImage, setLazyClass, { rootMargin: '150px' });
            }
        }
    }, [lazyload, lazyClass]);
    const Component = component || 'div';
    const styles = clsx(className, { [lazyClass]: isIntersecting || (!lazyload && lazyClass) });
    return (_jsx(Component, { ref: mergedRefs, ...other, className: styles, children: children }));
}
/**
 * A component for lazy loading images.
 *
 * When lazy loading images, the component is wrapper for the images being lazy loaded.
 *
 * When lazy loading classes, the class is applied to the component itself.
 */
export { LazyLoadContainer };
